import React from 'react'
import Navbar from './Navbar'
import '../contact.css'

function Contact(){
    return(
        <div>
            <Navbar/>
            <div id="home">
                <p className="desc-heading" data-aos="fade-up">Wanna invite us to an event? </p>
                <p className="desc">Shoot an invite email to espice.mirchi@gmail.com & dpsn.principal@gmail.com</p>
                <p className="desc-heading">Wanna contact our amazing teachers?</p>
                <main className="page-content">
                    <div className="card teachers" data-aos="fade-right" data-aos-duration="250">
                        <div className="content">
                            <h2 className="title">Monica Dewan</h2>
                            <p className="copy">Founder</p><p className="copy"></p></div>
                    </div>
                    <div className="card teachers" data-aos="fade-right" data-aos-duration="500">
                        <div className="content">
                            <h2 className="title">Vandana Sabharwal</h2>
                            <p className="copy"></p><p className="copy"></p></div>
                    </div>
                    <div className="card teachers" data-aos="fade-right" data-aos-duration="750">
                        <div className="content">
                            <h2 className="title">Shweta Malik</h2>
                            <p className="copy"></p><p className="copy"></p></div>
                    </div>
                    <div className="card teachers" data-aos="fade-right" data-aos-duration="1000">
                        <div className="content">
                            <h2 className="title">Balpreet Bakshi</h2>
                            <p className="copy"></p><p className="copy"></p></div>
                    </div>
                    <div className="card teachers" data-aos="fade-right" data-aos-duration="1000">
                        <div className="content">
                            <h2 className="title">Sunita Rawat</h2>
                            <p className="copy"></p><p className="copy"></p></div>
                    </div>
                    <div className="card teachers" data-aos="fade-right" data-aos-duration="1000">
                        <div className="content">
                            <h2 className="title">Preeti Vasudevan</h2>
                            <p className="copy"></p><p className="copy"></p></div>
                    </div>
                </main>
                <p className="desc-heading">CORE team contact info</p>
                <main className="page-content">
                    <div className="card core" data-aos="zoom-in-right" data-aos-duration="333.333">
                        <div className="content">
                            <h2 className="title">Rahul Tandon</h2>
                            <p className="copy"></p><p className="copy"></p></div>
                    </div>
                    <div className="card core" data-aos="zoom-in-right" data-aos-duration="666.666">
                        <div className="content">
                            <h2 className="title">Chirag</h2>
                            <p className="copy"></p><p className="copy"></p></div>
                    </div>
                    <div className="card core" data-aos="zoom-in-right" data-aos-duration="999.999">
                        <div className="content">
                            <h2 className="title">Ravit Gulati</h2>
                            <p className="copy"></p><p className="copy"></p></div>
                    </div>
                </main>
                <p className="desc-heading">Find us on Google Maps</p>
                <div className="mapouter" data-aos="fade-left">
                    <div className="gmap_canvas">
                        <div className="iframe-container">
                            <iframe class="responsive-iframe" id="gmap_canvas" src="https://maps.google.com/maps?q=delhi%20public%20school%20noida&t=&z=13&ie=UTF8&iwloc=&output=embed" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact